export enum ProductTypeEnum {
  Principal = 1,
  Inferior = 2,
}
